import Storage from "../util/Storage";

export async function logout() {
  Storage.removeToken();
}
